// Patient Database state. Both search and current page live here so the
// list view restores correctly when the user navigates away and back.

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchQuary: "",
  currentPage: 1,
};

const patientDatabaseSlice = createSlice({
  name: "patientDatabase",
  initialState,
  reducers: {
    setSearchQuary: (state, action) => {
      state.searchQuary = action.payload;
      // Any change in filters (search, sort, tag) must reset pagination —
      // otherwise filtering down to fewer pages leaves the user on a
      // non-existent page and the table renders empty.
      state.currentPage = 1;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    resetCurrentPage: (state) => {
      state.currentPage = 1;
    },
  },
});

export const { setSearchQuary, setCurrentPage, resetCurrentPage } =
  patientDatabaseSlice.actions;

export default patientDatabaseSlice.reducer;
